import React from "react";

import "./App.css";

import DashboardProvider from "./context/DashboardProvider";
import Firebase, { FirebaseContext, baseFirebaseApp } from "./firebase";
import Router from "./Router";

const FirebaseInstance = new Firebase(baseFirebaseApp);

const App = () => (
  <FirebaseContext.Provider value={FirebaseInstance}>
    <DashboardProvider>
      <Router />
    </DashboardProvider>
  </FirebaseContext.Provider>
);

export default App;
